import { Box, Text } from '@chakra-ui/react'
import React from 'react'
import HamburgerIcon from '../../../../components/SvgIcon/icons/Hamburger'

export function LabelComponent() {
  const handleCapacitaciones = () => {
    window.open('https://amipass.com/promos-app/', '_blank')
  }

  return (
    <Box
      pt={2}
      pb={2}
      w="100%"
      gap={3}
      bottom={0}
      display="flex"
      cursor="pointer"
      flexDirection="row"
      position="absolute"
      alignItems="center"
      justifyContent="center"
      backgroundColor="#E8C9C2"
      onClick={handleCapacitaciones}
    >
      <HamburgerIcon />
      <Text fontWeight={700}>Encuentra todas las promociones aquí</Text>
    </Box>
  )
}
